import _toConsumableArray from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.btoa.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import store from '@/store';
import configInfo from '@/config';
import CryptoJS from 'crypto-js/crypto-js';
var env = process.env.VUE_APP_ENV;
var obsEnviro = '';
var alipayConfig = '';
if (env === 'development') {
  obsEnviro = 'dev';
  alipayConfig = 'development';
} else if (env === 'test') {
  obsEnviro = 'test';
  alipayConfig = 'test';
} else {
  obsEnviro = 'prod';
  alipayConfig = 'production';
}
var Config = {
  obsEnviro: obsEnviro,
  alipayConfig: alipayConfig,
  bucketName: obsEnviro + '-ubq',
  // 桶
  pubilcBucketName: obsEnviro + '-public-res',
  // 公共桶
  udfsPreviewBaseUrl: 'https://api.udfs.one:15009/ipfs' // 外网
};
var obsClient = new window.ObsClient({
  access_key_id: 'GOIMR3OQIJZHR2ZOLCQI',
  secret_access_key: 'zNFf1fNZ33ZiAEvb0UvSXqoSiHHrJvzoqpZdL0Bj',
  server: 'https://obs.cn-south-1.myhuaweicloud.com'
});

/**
 * 获取OBS地址
 * @param fileBucket 桶名
 * @param fileKey 文件下载HASH
 *  @param hasPublic 是否为公共桶
 */
var getObsUrl = function getObsUrl(fileKey, fileBucket) {
  var hasPublic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isVideo = arguments.length > 3 ? arguments[3] : undefined;
  if (!fileBucket) {
    fileBucket = hasPublic ? Config.pubilcBucketName : Config.bucketName;
  }
  if (fileKey.indexOf('obs_Qm') >= 0) {
    fileBucket = 'prod-sync-store';
  }
  if (fileKey.indexOf('$') >= 0) {
    fileBucket = fileKey.substring(fileKey.indexOf('$') + 1);
  }

  // 通过算法算出地址
  var res = obsClient.createSignedUrlSync({
    Method: 'GET',
    Bucket: fileBucket,
    Key: fileKey,
    Expires: 3600
  });
  if (isVideo) {
    return res.SignedUrl + '&random=' + Math.random() + '.mp4';
  } else {
    return res.SignedUrl + '&random=' + Math.random();
  }
};

// obs 上传
function obsUploadHanld(_ref) {
  var fileName = _ref.fileName,
    file = _ref.file,
    bucketName = _ref.bucketName,
    proFn = _ref.proFn;
  return new Promise(function (resolve, reject) {
    obsClient.putObject({
      Bucket: bucketName,
      Key: fileName,
      SourceFile: file,
      ProgressCallback: function ProgressCallback(transferredAmount, totalAmount, totalSeconds) {
        // 获取上传平均速率（KB/S）
        var uploadSpeed = transferredAmount * 1.0 / totalSeconds / 1024;
        // 获取上传进度百分比
        var uploadPercent = transferredAmount * 100.0 / totalAmount;
        if (proFn) {
          proFn(uploadSpeed, uploadPercent);
        }
      }
    }).then(function (result) {
      resolve(result);
    }).catch(function (err) {
      reject(err);
    });
  });
}

/**
 * 判断是否在原生App的webview内并返回对应版本
 */

export function getAppInfo() {
  var ua = navigator.userAgent.toLowerCase();
  // const ua = " ecopyright_android/1.5.0 mozilla/5.0 (iphone; cpu iphone os 13_2_3 like mac os x) "
  var androidChar = 'ecopyright_android';
  var iosChar = 'ecopyright_ios';
  var isAndroid = ua.indexOf(androidChar) > -1;
  var isIos = ua.indexOf(iosChar) > -1;
  var result = null;
  var version;
  if (isAndroid || isIos) {
    var char = isAndroid ? androidChar : iosChar;
    var reg = new RegExp("".concat(char, "\\/([\\d\\.]+)")); // /ecopyright_ios\/([\d\.]+)/i
    version = ua.match(reg)[1];
    result = {};
    result.ecopyright = isAndroid ? 'android' : 'ios';
    if (version) result.version = version;
  }
  return result;
}

// 获取原生设备信息和生态
export var appInfo = getAppInfo();
var ecopyright = appInfo && appInfo.ecopyright;
var isAndroid = ecopyright === 'android';
var isiOS = ecopyright === 'ios';

/**
 * 获取obs文件地址
 * @param fileBucket obs桶名
 * @param fileKey 文件Key
 */
function getGeneralUrl(fileKey, fileBucket, isVideo) {
  if (!fileKey) return null;
  if (fileKey.indexOf('obs_') >= 0 && getObsUrl) {
    return getObsUrl(fileKey, fileBucket, null, isVideo);
  } else {
    return "/api/opservcenter/opsc/file/".concat(fileKey, "/file");
  }
}

/**
 * 获取公共数据文件方法
 * @param fileBucket 桶名
 * @param fileKey  文件下载HASH
 *  @param fileName 文件名
 *  @param source  数据来源
 */
function getPublicUrl(fileKey) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'img.png';
  var source = arguments.length > 2 ? arguments[2] : undefined;
  var fileBucket = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (!fileKey) return null;
  if (fileKey.indexOf('obs_') >= 0) {
    return getObsUrl(fileKey, fileBucket, true);
  }
  if (fileKey.indexOf('/api/opservcenter/') >= 0 || fileKey.indexOf('https') >= 0) {
    return fileKey;
  }
  return "/api/opservcenter/opsc/file/".concat(fileKey, "/").concat(fileName);
}
function urlToBase64(url) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;
      // 将图片插入画布并开始绘制
      canvas.getContext('2d').drawImage(image, 0, 0);
      // result
      var result = canvas.toDataURL('image/png');
      resolve(result);
    };
    // CORS 策略，会存在跨域问题
    image.setAttribute('crossOrigin', 'Anonymous');
    image.src = url;
    // 图片加载失败的错误处理
    image.onerror = function () {
      reject(new Error('urlToBase64 error'));
    };
  });
}

/**
 * 设置浏览器标签title
 * @param pageTitle
 */
function getPageTitle(pageTitle) {
  var title = '';
  if (appInfo) {
    title = pageTitle || '';
  } else {
    title = pageTitle ? "".concat(pageTitle, " - \u4F18\u7248\u6743") : '优版权';
  }
  return title;
}

/**
 * 获取udfs存储的图片
 * @param fileHash
 * @param fileName
 */
function getFile(fileHash) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'file';
  fileName = encodeURIComponent(fileName);
  // 兼容以前的数据
  if (!fileHash) return null;
  if (fileHash.indexOf('/api/opservcenter/') >= 0) {
    return fileHash;
  }
  return "/api/opservcenter/opsc/file/".concat(fileHash, "/").concat(fileName);
}

/**
 * 获取obs图片缩略图
 * param 请参考 https://support.huaweicloud.com/fg-obs/obs_01_0430.html
 */
function getThumbnail(param) {
  // eslint-disable-next-line
  var fileKey = param.fileKey,
    m = param.m,
    p = param.p,
    h = param.h,
    w = param.w,
    i = param.i,
    s = param.s,
    color = param.color,
    limit = param.limit;
  var url = getObsCdnUrl(fileKey);
  // 未传缩率参数则直接取CDN链接
  if ((!m || !w || !h) && url) {
    return "".concat(url, "/").concat(fileKey);
  }
  if (url) {
    return "".concat(url, "/").concat(fileKey, "?x-image-process=image/resize,m_").concat(m, ",w_").concat(w, ",h_").concat(h);
  } else {
    console.error('只支持obs');
  }
}

/**
 * 获取头像obs图片缩略图
 */
function getAvatarThumbnail(fileKey) {
  if (!fileKey) {
    return '';
  }
  if (fileKey.indexOf('http') >= 0) {
    return fileKey;
  }
  var url = getObsCdnUrl(fileKey, true);
  if (url) {
    return "".concat(url, "/").concat(fileKey, "?x-image-process=image/resize,m_mfit,w_200,h_200");
  } else {
    console.error('只支持obs');
  }
}
var obsCdnUrl = {
  dev: 'https://obs.dev.ubanquan.cn',
  test: 'https://obs.test.ubanquan.cn',
  prod: 'https://obs.prod.ubanquan.cn'
};
var obsPublicCdnUrl = {
  dev: 'https://obs.dev-public-res.ubanquan.cn',
  test: 'https://obs.test-public-res.ubanquan.cn',
  prod: 'https://obs.prod-public-res.ubanquan.cn'
};
function getObsCdnUrl(fileKey, hasPublic) {
  var cdnUrl = '';
  if (fileKey && fileKey.indexOf('obs_') >= 0) {
    var arr = fileKey.split('$');
    if (arr.length > 1) {
      var bucket = arr[1];
      if (bucket.indexOf('dev-public-res') !== -1) {
        cdnUrl = obsPublicCdnUrl.dev;
      } else if (bucket.indexOf('test-public-res') !== -1) {
        cdnUrl = obsPublicCdnUrl.test;
      } else if (bucket.indexOf('prod-public-res') !== -1) {
        cdnUrl = obsPublicCdnUrl.prod;
      } else if (bucket.indexOf('ipbank') !== -1) {
        cdnUrl = configInfo.cdnMLMUrl;
      } else if (bucket.indexOf('bwl') !== -1) {
        cdnUrl = configInfo.cdnBWLUrl;
      } else if (bucket.indexOf('prod') !== -1) {
        cdnUrl = obsCdnUrl.prod;
      } else if (bucket.indexOf('test') !== -1) {
        cdnUrl = obsCdnUrl.test;
      } else if (bucket.indexOf('dev') !== -1) {
        cdnUrl = obsCdnUrl.dev;
      }
    } else if (hasPublic && arr.length <= 1) {
      cdnUrl = obsPublicCdnUrl[obsEnviro];
    } else {
      cdnUrl = configInfo.cdnUrl;
    }
  }
  return cdnUrl;
}

/**
 * 根据文件类型获取NFR的封面图(缩略图)
 */
function getCoverImg(coverImg, fileType, firstFrame, config) {
  var videoType = ['mp4', 'avi'];
  var audioType = ['mp3'];
  if (fileType && (videoType.includes(fileType) || audioType.includes(fileType))) {
    return getThumbnail(_objectSpread({
      fileKey: firstFrame
    }, config));
  } else {
    return getThumbnail(_objectSpread({
      fileKey: coverImg
    }, config));
  }
}

/**
 * 获取是否为微信浏览器 & 获取版本
 */
function wechatInfo() {
  // eslint-disable-next-line no-useless-escape
  return navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
}

/**
 * 获取用户属性值
 */
function getUserAttribute(data, attrName) {
  if (!data || !data.attributes || !data.attributes.length) {
    return '';
  }
  var item = data.attributes.find(function (i) {
    return i.attribute === attrName;
  });
  return item && item.value ? item.value : '';
}

/**
 * 动态加载js资源
 * @param url js资源地址
 * @param callback 加载完成后的回调
 */
function loadScript(url, callback) {
  var script = document.createElement('script');
  var fn = callback || function () {};
  script.type = 'text/javascript';
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        fn('success');
      }
    };
  } else {
    // 其他浏览器
    script.onload = function () {
      fn('success');
    };
    script.onerror = function () {
      fn('fail');
    };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}

// 省市区地址库
var areaData = null;
var addressDataCDN = 'https://obs.prod-public-res.ubanquan.cn/H5Resource/addressData.js?version=1.0.0';

/**
 * 加载地区数据
 * @param callback 加载完成后的回调
 */
function loadAreaData() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  if (store.state.app.requestState === 'init') {
    // 初次才加载
    loadScript(addressDataCDN, function (requestState) {
      if (requestState === 'success') {
        // cdn加载成功 addressData为js导出对象
        // eslint-disable-next-line
        areaData = addressData;
      } else {
        console.log('地区数据加载失败');
      }
      callback(areaData);
      // 记录cdn加载状态
      store.commit('app/SET_REQUEST_STATE', requestState);
    });
  } else {
    callback(areaData);
  }
}

/**
 * 获取当前地区
 * @param value 完整的地区json数据
 * @param dataJson 省市区街道对应的code码 取最后一个即可 例如精确到街道，就只传街道对应的code
 */
function getLocationData(value) {
  var dataJson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : areaData;
  for (var i = 0; i < dataJson.length; i++) {
    var data = dataJson[i];
    if (data.code === value) {
      return [data];
    }
    if (data.children) {
      var selectedOptions = getLocationData(value, data.children);
      if (selectedOptions) {
        return [data].concat(selectedOptions);
      }
    }
  }
}

/**
 * 获取当前地区对应的文本
 * @param value 完整的地区json数据
 * @param separator 省市区街道对应的code码 取最后一个即可 例如精确到街道，就只传街道对应的code
 */

function getLocationText(value, separator) {
  var data = getLocationData(value);
  var result = [];
  data.forEach(function (item) {
    if (item.name !== '市辖区') result.push(item.name);
  });
  return result.join(separator);
}
function byteLength(str, indexOf) {
  if (!str) return 0;
  var b = 0;
  var l = str.length;
  var i = 0;
  for (; i < l; i++) {
    if (b >= indexOf) {
      break;
    }
    if (str.charCodeAt(i) > 255) {
      b += 2;
    } else {
      b++;
    }
  }
  if (indexOf) {
    return i;
  }
  return b;
}
function compressImage(file) {
  return new Promise(function (resolve, reject) {
    // 获取图片（加载图片是为了获取图片的宽高）
    var img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onerror = function (error) {
      return reject(error);
    };
    img.onload = function () {
      var originWidth = img.width,
        originHeight = img.height;
      // 最大尺寸限制
      var maxWidth = 1000;
      var maxHeight = 1000;
      // 需要压缩的目标尺寸
      var targetWidth = originWidth;
      var targetHeight = originHeight;
      // 等比例计算超过最大限制时缩放后的图片尺寸
      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > 1) {
          // 宽图片
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          // 高图片
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
      // 创建画布
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      // 设置宽高度为等同于要压缩图片的尺寸
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.clearRect(0, 0, targetWidth, targetHeight);
      // 将img绘制到画布上
      context.drawImage(img, 0, 0, targetWidth, targetHeight);
      canvas.toBlob(function (file) {
        return resolve(file);
      }, 'image/jpeg', 0.8);
    };
  });
}

/**
 * 除法（解决精度丢失）
 * arg1 被除数
 * arg2 除数
 */
export function accDiv(arg1, arg2, hasNum) {
  if (!arg1 || !arg2) {
    return 0;
  }
  var str1 = arg1.toString();
  var str2 = arg2.toString();
  var t1 = 0;
  var t2 = 0;
  if (str1.indexOf('.') > 0) {
    t1 = str1.split('.')[1].length;
  }
  if (str2.indexOf('.') > 0) {
    t2 += str2.split('.')[1].length;
  }
  var r1 = Number(arg1.toString().replace('.', ''));
  var r2 = Number(arg2.toString().replace('.', ''));
  var res = accMul(r1 / r2, Math.pow(10, t2 - t1)) + '';
  if (res.indexOf('.') < 0) {
    res += '.00';
  }
  if (hasNum) {
    return Number(res);
  }
  return res;
}

/**
 * 乘法（解决精度丢失）
 * arg1 被除数
 * arg2 除数
 */
export function accMul(arg1, arg2) {
  if (!arg1 || !arg2) {
    return 0;
  }
  var m = 0;
  var s1 = arg1.toString();
  var s2 = arg2.toString();
  if (s1.indexOf('.') > 0) {
    m += s1.split('.')[1].length;
  }
  if (s2.indexOf('.') > 0) {
    m += s2.split('.')[1].length;
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

// 加法
function accAdd(arg1, arg2) {
  var r1, r2;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  var m = Math.pow(10, Math.max(r1, r2));
  var res = (arg1 * m + arg2 * m) / m + '';
  if (res.indexOf('.') < 0) {
    res += '.00';
  }
  return res;
}

// 减法
function accSubtr(arg1, arg2) {
  var r1, r2;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  var m = Math.pow(10, Math.max(r1, r2));
  var n = r1 >= r2 ? r1 : r2;
  var res = ((arg1 * m - arg2 * m) / m).toFixed(n);
  if (res.indexOf('.') < 0) {
    res += '.00';
  }
  return res;
}

// 防抖
function debounce() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var timer = null;
  return function () {
    var _arguments = arguments,
      _this = this;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(_this, _arguments);
    }, wait);
  };
}

// 截流
function throttle() {
  var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var timer = null;
  return function () {
    var _arguments2 = arguments,
      _this2 = this;
    if (timer) {
      return;
    }
    timer = setTimeout(function () {
      fn.apply(_this2, _arguments2);
      timer = null;
    }, wait);
  };
}

/**
 * @param num 数字
 * @description 阿拉伯数字转中文数字
 * */
function toChinesNum(num) {
  var strNum = String(num);
  var unit = ['十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千'];
  var result = ['@'];
  var unitNo = 0;
  var chineseBigNum = '零一二三四五六七八九';
  // 从后往前遍历接收到的数据，省略结束条件
  for (var i = strNum.length - 1;; i--) {
    // 调用转大写函数，将每一个数字转换成中文大写，一次放入一个到结果数组中
    result.unshift(chineseBigNum[strNum[i]]);
    // 如果不大于0
    if (i <= 0) {
      // 结束循环
      break;
    }
    // 放入一个数字，放入一个单位
    result.unshift(unit[unitNo]);
    // 单位下标加1
    unitNo++;
  }
  // 将结果数组转换成字符串，并使用正则替换一些关键位置，让结果符合语法
  // return result.join('').replace(/(零[仟佰拾]){1,3}/g, '零').replace(/零{2,}/g, '零').replace(/零([万亿])/g, '$1').replace(/亿万/g, '亿').replace(/零*@/g, '')
  return result.join('').replace(/(零[千百十]){1,3}/g, '零').replace(/零{2,}/g, '零').replace(/零([万亿])/g, '$1').replace(/亿万/g, '亿').replace(/零*@/g, '');
}

/*
 * 判断浏览器类型
 * */
var isBrowser = function isBrowser() {
  var ua = navigator.userAgent;
  var version = {
    isIos: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    // ios 终端
    // isMobile: !!ua.macth(/(iPhone|iPod|iPad|Android|ios)/i), // 是否移动终端
    isMobile: !!ua.match(/AppleWebKit.*Mobile.*/),
    // 是否移动终端
    isAndroid: ua.indexOf('android') > -1 || ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1,
    // android 终端端或者uc 浏览器
    // isAndroid: !!appVersion.match(/android/gi),
    isIphone: ua.indexOf('iphone') > -1 || ua.indexOf('iPhone') > -1,
    // 是否为iPhone或则QQHD浏览器
    // isIphone:  !!appVersion.match(/iphone/gi);
    iPad: ua.indexOf('iPad') > -1,
    // 是否是iPad
    isWebApp: ua.indexOf('Safari') === -1,
    // 是否为Webapp，没有头部和底部
    isTrident: ua.indexOf('Trident') > -1,
    // IE内核
    isPresto: ua.indexOf('Presto') > -1,
    // opera 内核
    isWebKit: ua.indexOf('AppleWebkit') > -1,
    // 苹果谷歌内核
    isGecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1,
    // 火狐内核
    isWechat: !!ua.match(/micromessenger/gi),
    // 微信浏览器
    isWeiBo: !!ua.match(/weibo/gi),
    // 微博
    isQQ: !!ua.match(/qq/gi),
    // qq
    isSafari: /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent),
    // safari
    isQuark: !!ua.match(/Quark/gi) // 夸克
  };
  var language = (navigator.browserLanguage || navigator.language).toLowerCase();
  return _objectSpread(_objectSpread({}, version), {}, {
    language: language
  });
};

// 获取系统版本
var getOsVersion = function getOsVersion() {
  var u = navigator.userAgent;
  var version = '';
  if (u.indexOf('Mac OS X') > -1) {
    // ios
    var regStr_saf = /OS [d._]*/gi;
    var verinfo = u.match(regStr_saf);
    version = 'IOS' + (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
  } else if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    // android
    version = 'Android' + u.substr(u.indexOf('Android') + 8, u.indexOf(';', u.indexOf('Android')) - u.indexOf('Android') - 8);
  } else if (u.indexOf('BB10') > -1) {
    // 黑莓bb10系统
    version = 'blackberry' + u.substr(u.indexOf('BB10') + 5, u.indexOf(';', u.indexOf('BB10')) - u.indexOf('BB10') - 5);
  } else if (u.indexOf('IEMobile') > -1) {
    // windows phone
    version = 'winphone' + u.substr(u.indexOf('IEMobile') + 9, u.indexOf(';', u.indexOf('IEMobile')) - u.indexOf('IEMobile') - 9);
  } else {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('windows nt 5.0') > -1) {
      version = 'Windows 2000';
    } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
      version = 'Windows XP';
    } else if (userAgent.indexOf('windows nt 6.0') > -1) {
      version = 'Windows Vista';
    } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
      version = 'Windows 7';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
      version = 'Windows 8';
    } else if (userAgent.indexOf('windows nt 6.3') > -1) {
      version = 'Windows 8.1';
    } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
      version = 'Windows 10';
    } else {
      version = 'Unknown';
    }
  }
  return version;
};

// base64编码
var base64Encode = function base64Encode(str) {
  return window.btoa(window.encodeURIComponent(str));
};
// base64解码
var base64Decode = function base64Decode(str) {
  return window.decodeURIComponent(window.atob(str));
};

// dataURLtoFile
var dataURLtoFile = function dataURLtoFile(url, filename) {
  try {
    var arr = url.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = window.atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
      type: mime
    });
  } catch (err) {
    return false;
  }
};
function setCss(obj, css) {
  for (var attr in css) {
    obj.style[attr] = css[attr];
  }
}

// iframe跳转进入富友签约页
export var initIframeToLink = function initIframeToLink(url, cb) {
  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var FYIframe = document.createElement('iframe');
  var iframeStyle = {
    position: 'fixed',
    width: "".concat(window.innerWidth || document.body.innerWidth, "px"),
    height: "".concat(window.innerHeight || document.body.innerHeight, "px"),
    top: '0',
    left: '0',
    zIndex: '9998',
    background: '#FFF',
    border: 'none',
    paddingTop: '44px'
  };
  setCss(FYIframe, iframeStyle);
  FYIframe.src = url;
  var BackImg = document.createElement('img');
  var BackImgStyle = {
    position: 'fixed',
    width: '32px',
    height: '32px',
    top: '8px',
    left: '8px',
    zIndex: '9999'
  };
  setCss(BackImg, BackImgStyle);
  // BackImg.id = 'third-iframe-close-icon'
  BackImg.src = 'https://obs.prod.ubanquan.cn/obs_011602162900001660207344_pre$prod-ubq';
  document.documentElement.appendChild(FYIframe);
  document.documentElement.appendChild(BackImg);
  var closeIframe = function closeIframe(cb, immediate) {
    if (cb && typeof cb === 'function' && immediate) {
      cb();
    }
    setTimeout(function () {
      document.documentElement.removeChild(BackImg);
      document.documentElement.removeChild(FYIframe);
      window.closeIframe = null;
      window.cb = null;
    }, 0);
  };
  // 注册全局关闭iframe方法
  window.closeIframe = closeIframe;
  window.cb = cb || null;

  // 点击返回图标关闭iframe
  BackImg.addEventListener('click', function () {
    closeIframe(cb, immediate);
  });
};

// const objectReg = new RegExp(/^\{.*?}$/g)
// const arrayReg = new RegExp(/^\[.*?]$/g)
// const numberReg = new RegExp(/^(\-|\+)?\d+(\.\d+)?$/g)
/**
 * 获取缓存信息
 * */
var getStorage = function getStorage() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';
  return function () {
    var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var dataString = window[storage].getItem(field);
    if (dataString) {
      var isObject = /^\{.*?}$/g.test(dataString); // 匹配是否{}对象字符串
      var isArray = /^\[.*?]$/g.test(dataString); // 匹配是否[]数组字符串
      var isNumber = /^(\-|\+)?\d+(\.\d+)?$/g.test(dataString); // 匹配是否数组字符串
      if (isObject || isArray || isNumber || dataString === 'true' || dataString === 'false') {
        try {
          return JSON.parse(dataString);
        } catch (error) {
          console.log("\u83B7\u53D6".concat(storage, "\u5F02\u5E38:"), error);
        }
      } else {
        return dataString;
      }
    }
    return null;
  };
};

/**
 * 设置缓存信息
 * */
var setStorage = function setStorage() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';
  return function () {
    var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = arguments.length > 1 ? arguments[1] : undefined;
    try {
      window[storage].setItem(field, typeof value !== 'string' ? JSON.stringify(value) : value);
    } catch (error) {
      console.log("\u83B7\u53D6".concat(storage, "\u5F02\u5E38:"), error);
    }
  };
};

/**
 * 清除缓存信息
 * */
export var removeStorage = function removeStorage() {
  var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';
  return function () {
    var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return window[storage].removeItem(field);
  };
};
export var setSessionStorageKey = setStorage('sessionStorage');
export var getSessionStorageKey = getStorage('sessionStorage');
export var removeSessionStorageKey = removeStorage('sessionStorage');
export var setLocalStorageKey = setStorage('localStorage');
export var getLocalStorageKey = getStorage('localStorage');
export var removeLocalStorageKey = removeStorage('localStorage');

/**
 * 数组去重
 * */
export var unique = function unique() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var uniId = arguments.length > 1 ? arguments[1] : undefined;
  var res = new Map();
  return arr.filter(function (item) {
    return !res.has(item[uniId]) && res.set(item[uniId], 1);
  });
};
var isStandalone = window.navigator.standalone;

/**
 * @param data 对象
 * @param fields 数组
 * @description 从data中挑选fields中的元素，返回一个新对象
 * */
export var pick = function pick() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!fields.length) {
    return data;
  }
  var temp = {};
  fields.forEach(function (x) {
    temp[x] = data[x] || '';
  });
  return temp;
};

// 默认的 KEY 与 iv 如果没有给
var KEY = CryptoJS.enc.Utf8.parse('4044ys1230thwlWB'); // ""中与后台一样  密码
var IV = CryptoJS.enc.Utf8.parse(); // ""中与后台一样

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt(word, keyStr, ivStr) {
  var key = KEY;
  var iv = IV;
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function Decrypt(word, keyStr, ivStr) {
  var key = KEY;
  var iv = IV;
  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }
  var base64 = CryptoJS.enc.Base64.parse(word);
  var src = CryptoJS.enc.Base64.stringify(base64);
  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

// 判断两个版本号的大小 v1>=v2 = true
export function CompareVersion(v1, v2) {
  if (v1 === v2) {
    return true;
  }
  var vs1 = v1.split('.').map(function (v) {
    return parseInt(v);
  });
  var vs2 = v2.split('.').map(function (v) {
    return parseInt(v);
  });
  var len = Math.min(vs1.length, vs2.length);
  for (var i = 0; i < len; i++) {
    if (vs1[i] > vs2[i]) {
      return true;
    } else if (vs1[i] < vs2[i]) {
      return false;
    }
  }
  return len !== vs1.length;
}

// 分割地址
export function sliceAddress(address) {
  var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  if (!address) {
    return '';
  }
  if (address.length > 40) {
    return address.slice(0, num) + '...' + address.slice(address.length - num);
  }
  return address;
}

/**
 * 简易深拷贝
 * 不能拷贝以下数据
 * 含 html-dom
 * 含 function
 */
export function deepClone(source, cache) {
  if (!cache) {
    cache = new Map();
  }
  if (source instanceof Object) {
    // 不考虑跨 iframe
    if (cache.get(source)) {
      return cache.get(source);
    }
    var result;
    if (source instanceof Array) {
      result = [];
    } else if (source instanceof Date) {
      result = new Date(source - 0);
    } else if (source instanceof RegExp) {
      result = new RegExp(source.source, source.flags);
    } else {
      result = {};
    }
    cache.set(source, result);
    for (var key in source) {
      if (Object.hasOwnProperty.call(source, key)) {
        result[key] = deepClone(source[key], cache);
      }
    }
    return result;
  } else {
    return source;
  }
}

/**
 * 筛选数据过滤
 */
export var screenDataFilter = function screenDataFilter(dataList) {
  return function (filterList, key) {
    var _ITEM$data;
    var item = filterList.find(function (v) {
      return v.field === key;
    });
    var ITEM = dataList.find(function (x) {
      return x.field === key;
    });
    item ? item.children = _toConsumableArray((_ITEM$data = ITEM === null || ITEM === void 0 ? void 0 : ITEM.data) !== null && _ITEM$data !== void 0 ? _ITEM$data : []) : null;
  };
};

/*
 * 获取元素的width
 * */
export var getTargetElementStyleUnit = function getTargetElementStyleUnit(el, styleAttr) {
  if (el && styleAttr) {
    var targetStyle = window.getComputedStyle(el)[styleAttr];
    var px = targetStyle.replace('px', '');
    return isNaN(+px) ? 0 : +px;
  }
  return 0;
};
/*
 * 判断是否是第三方登录回到项目 并 显示登录弹窗
 * */
export var isThirdPartyLogin = function isThirdPartyLogin() {
  var urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('code');
};
export default {
  Config: Config,
  obsClient: obsClient,
  appInfo: appInfo,
  isAndroid: isAndroid,
  isiOS: isiOS,
  obsUploadHanld: obsUploadHanld,
  getFile: getFile,
  getGeneralUrl: getGeneralUrl,
  getPublicUrl: getPublicUrl,
  getThumbnail: getThumbnail,
  getCoverImg: getCoverImg,
  getPageTitle: getPageTitle,
  wechatInfo: wechatInfo,
  getUserAttribute: getUserAttribute,
  getLocationData: getLocationData,
  getLocationText: getLocationText,
  urlToBase64: urlToBase64,
  loadAreaData: loadAreaData,
  byteLength: byteLength,
  compressImage: compressImage,
  accSubtr: accSubtr,
  accAdd: accAdd,
  accDiv: accDiv,
  accMul: accMul,
  getAvatarThumbnail: getAvatarThumbnail,
  loadScript: loadScript,
  debounce: debounce,
  throttle: throttle,
  toChinesNum: toChinesNum,
  isBrowser: isBrowser,
  base64Encode: base64Encode,
  base64Decode: base64Decode,
  getOsVersion: getOsVersion,
  dataURLtoFile: dataURLtoFile,
  initIframeToLink: initIframeToLink,
  isStandalone: isStandalone,
  pick: pick,
  Encrypt: Encrypt,
  Decrypt: Decrypt,
  CompareVersion: CompareVersion,
  setSessionStorageKey: setSessionStorageKey,
  getSessionStorageKey: getSessionStorageKey,
  removeSessionStorageKey: removeSessionStorageKey,
  sliceAddress: sliceAddress,
  deepClone: deepClone,
  getObsCdnUrl: getObsCdnUrl,
  isThirdPartyLogin: isThirdPartyLogin
};